import { render, staticRenderFns } from "./OcrWorkbench.vue?vue&type=template&id=725905d8&scoped=true"
import script from "./OcrWorkbench.vue?vue&type=script&lang=js"
export * from "./OcrWorkbench.vue?vue&type=script&lang=js"
import style0 from "./OcrWorkbench.vue?vue&type=style&index=0&id=725905d8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725905d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725905d8')) {
      api.createRecord('725905d8', component.options)
    } else {
      api.reload('725905d8', component.options)
    }
    module.hot.accept("./OcrWorkbench.vue?vue&type=template&id=725905d8&scoped=true", function () {
      api.rerender('725905d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/imgorder/OcrWorkbench.vue"
export default component.exports